import { render, staticRenderFns } from "./tiSettingDialog.vue?vue&type=template&id=2d24323d"
import script from "./tiSettingDialog.vue?vue&type=script&lang=js"
export * from "./tiSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./tiSettingDialog.vue?vue&type=style&index=0&id=2d24323d&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports